import {
  mapGetters,
  mapMutations,
} from 'vuex';

export default {
  name: 'TireLocationPickerItem',
  components: {},
  props: {
    tireLocationState: null,
  },
  data: () => ({}),
  computed: {
    ...mapGetters('appointment', {
      tireType: 'getTireType',
    }),
    typeTypeStock() {
      return `${this.tireType}Stock`;
    },
    classObject() {
      let classObject = `${this.tireLocationState.position}`;

      switch (this.tireLocationState[this.typeTypeStock]) {
        case 0:
          classObject += ' is-disabled';
          break;
        case 2:
          classObject += ' is-active';
          break;
        case 3:
          classObject += ' on-stock';
          break;
        default:
          break;
      }

      return classObject;
    },
  },
  methods: {
    ...mapMutations('appointment', {
      setTireLocationMutation: 'SET_TIRELOCATION',
    }),
    changeTireLocationState() {
      // 0 is disabled, 3 is on-stock
      if (this.tireLocationState[this.typeTypeStock] !== 0 &&
        this.tireLocationState[this.typeTypeStock] !== 3) {
        const changeTireLocationStateObject = {
          state: this.tireLocationState[this.typeTypeStock] === 1 ? 2 : 1,
          position: this.tireLocationState.position,
          stockType: this.typeTypeStock,
        };

        this.setTireLocationMutation(changeTireLocationStateObject);
      }
    },
  },
};
